import { useSelector } from 'react-redux';
import { areAllPendingInlineEditsValidSelector } from './inlineEditingSlice';
export const usePendingInlineEditsAreValid = () => {
  return useSelector(areAllPendingInlineEditsValidSelector);
};